import React from 'react';
import * as PropTypes from 'prop-types';
import Ico24 from '../Ico24';
import { ElementWrapper } from './elements';
import { ICON } from 'resources/constants';

function Lab122(props) {
  return props.expanded ? (
    <div onClick={props.onClick}>
      {props.children}
      <ElementWrapper>
        <Ico24 color={'#546E7A'} icon={ICON.keyboardArrowUp} />
      </ElementWrapper>
    </div>
  ) : (
    <ElementWrapper onClick={props.onClick}>
      <Ico24 color={'#546E7A'} icon={ICON.keyboardArrowDown} />
    </ElementWrapper>
  );
}

Lab122.propTypes = {
  children: PropTypes.node,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Lab122;
